export default __webpack_public_path__ + "static/media/before@2x.bd6aead0.png";